import { createSelector } from "reselect"
import { get, chain, pickBy } from "lodash"
import moment from "moment"
import { getModelCategories } from "selectors/modelMetadata"
import { getAllItems, getOrderedCategoryItems } from "./items"
import { getFavoriteFactors } from "modules/portfolio-root/selectors/portfolios"
import { getExposure, getFilteredExposure, getFirst, getCurrent } from "./exposure"
import { computeCategoryItemsSubset, computeCategoryItems, computeDisplayCategories, computeNonZerosKeys, computeOptions } from "helpers/analyze"
import { makeComputeDriftFromData } from "helpers/drift"

export function computeData(items, exposure) {
  return chain(exposure)
    .map((datum, index) => {
      const { date } = datum
      const result = chain(items)
        .map(item => {
          return ([
            item.id,
            item.fn
              ? item.fn(datum)
              : get(datum, item.field, 0),
          ])
        })
        .filter(([, value]) => !Number.isNaN(value))
        .fromPairs()
        .value()

      result.date = moment(date)
      result.index = index

      return result
    })
    .filter(datum => datum)
    .value()
}

export const getData = createSelector(
  [getAllItems, getFilteredExposure],
  (items, exposure) => computeData(items, exposure),
)

const getNonZerosKeys = createSelector(
  [getData, getFavoriteFactors],
  computeNonZerosKeys,
)

export const getFilteredData = createSelector(
  [getData, getNonZerosKeys],
  (data, keys) => data.map(item => pickBy(item, (item, key) => keys[key])),
)

export const getCategoryItemsSubset = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  computeCategoryItemsSubset,
)

export const getCategoryItems = createSelector(
  [getOrderedCategoryItems, getNonZerosKeys],
  computeCategoryItems,
)

export const getDisplayCategories = createSelector(
  [getAllItems, getNonZerosKeys],
  computeDisplayCategories,
)

export const getOptions = createSelector(
  [getModelCategories, getFirst, getCurrent, getDisplayCategories],
  computeOptions,
)

export const getDrift = createSelector(
  [getExposure],
  makeComputeDriftFromData(item => item.factors),
)
